import React, { useEffect, useState, useContext } from "react"
import MainContext from "../../context/MainContext";
import Container from "../../ui/Container/Container";
import Row from "../../ui/Row/Row";
import Button from "../../ui/Button/Button";
import { sendEvaluationFormAnswers } from "../../api/functions"
import classNames from "classnames";
import "./EvaluationForm.scss"

const EvaluationForm = (props) => {
    const [modalOpen, setModalOpen] = useState(false)
    const context = useContext(MainContext)
    const [episode, setEpisode] = useState()
    const [loading, setLoading] = useState(false)
    const [answers, setAnswers] = useState({})
    const [formFeedback, setFormFeedback] = useState()
    const [formErrors, setFormErrors] = useState([])
    const [answered, setAnswered] = useState([])

    const { user } = props
    // const userEpisodes = window._.get(user, `questions`, []).filter(item => item.is_evaluation_open)
    const userOpenQuestions = window._.get(user, `questions`, [])
    const userEpisodes = window._.get(user, `episodes`, []).filter(item => item.is_evaluation_open && userOpenQuestions.includes(item.id))
    const questionsCategories = window._.get(episode, "evaluation_questions")

    useEffect(() => {
        if (userEpisodes.length === 1) {
            setEpisode(userEpisodes[0])
        }
    }, [user])

    useEffect(() => {
        setModalOpen(props.open)
    }, [props.open])

    const isModal = () => {
        return props.modal
    }

    const onChange = (key, e) => {
        const value = e.target.value
        setAnswers({
            ...answers,
            [key]: value
        })
    }

    const buttonIsDisabled = () => {
        if (!answers) {
            return false
        }
        let answersResults = []
        Object.keys(answers).forEach(k => {
            answersResults.push(answers[k])
        })
        let questionsCOunt = 0
        if (questionsCategories) {
            questionsCategories.forEach(cat => {
                questionsCOunt += cat.evaluationquestions.length
            })
        }
        return (
            !questionsCategories ||
            loading ||
            answersResults.filter(item => !!item).length !== questionsCOunt
        )
    }

    const sendAnswers = async () => {
        setFormFeedback(formFeedback => {
            return {
                ...formFeedback,
                [episode.id]: null
            }
        })
        setFormErrors()
        setLoading(true)
        try {
            const res = await sendEvaluationFormAnswers({
                episode_id: episode.id,
                answers: answers
            })
            setFormFeedback(formFeedback => {
                let ff = formFeedback
                ff[episode.id] = "Thank you for your time!"
                return ff
            })
            // setFormFeedback("Thank you for your time!")
            setAnswered(answered => answered.concat(episode.id))
            setAnswers()
            // props.setEvaluationFormAnswered(true)
            // window.setTimeout(() => {
            //     close()
            // }, 2000)
        }
        catch (e) {
            const newErrors = window._.get(e, "response.data.message")
            setFormErrors(newErrors)
        }
        finally {
            setLoading(false)
        }
    }

    const close = () => {
        setFormErrors()
        setFormFeedback()
        props.closeEvaluartionFormModal()
    }

    const grid = episode ? window._.get(props.answered, episode.id) ? ( //window._.get(props.answered, episode.id)
        <Container fluid={true}>
            <Row className="my-2 py-4 px-2">
                <div className="col">
                    {props.alreadyAnsweredMessage}
                </div>
            </Row>
        </Container>
    ) : (
        <Container fluid={true}>
            <Row>
                <div
                    className="col mt-3 mx-3 px-0 pb-3 form-category__title"
                >
                    {
                        userEpisodes.length > 1 ? (
                            <i
                                class="fas fa-chevron-left  mr-3"
                                style={{ cursor: "pointer" }}
                                onClick={() => setEpisode()}
                            ></i>
                        ) : null
                    }
                    <div className="h4">{episode.evaluation_form_title || episode.title}</div>
                    {episode.episode_categories && (
                        <div className="h6">
                            {episode.episode_categories.map(cat => cat.title_default)}
                        </div>
                    )}
                </div>
            </Row>
            {
                window._.get(formFeedback, episode.id) ? (
                    <Row>
                        <div className="col py-3">
                            {window._.get(formFeedback, episode.id)}
                        </div>
                    </Row>
                ) : questionsCategories ? questionsCategories.map((category, index) => {
                    return (
                        <div key={`question-category-${index}`}>
                            {
                                category.evaluationquestions.length ? (
                                    <Row>
                                        <div
                                            className="col h5 mt-3 mx-3 px-0 pb-3 form-category__title"
                                        >
                                            {category.title}
                                        </div>
                                    </Row>
                                ) : null
                            }

                            <div>
                                {
                                    category.evaluationquestions.map(item => {

                                        const answer = (!item.question_type) ? (
                                            <textarea
                                                onChange={(e) => onChange(item.id, e)}
                                                className="form-control form-control-lg"
                                            ></textarea>
                                        ) : item.is_radio ? (
                                            <div>
                                                {
                                                    item.options ? item.options.map(option => {
                                                        return (
                                                            <div
                                                                key={`option-${index}-${option}`}
                                                                className="form-check">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name={`option-${index}`}
                                                                    value={option}
                                                                    onChange={(e) => onChange(item.id, e)}
                                                                />
                                                                <label className="form-check-label" htmlFor="exampleRadios3">
                                                                    {option}
                                                                </label>
                                                            </div>
                                                        )
                                                    }) : null
                                                }
                                            </div>
                                        ) : (
                                            <select
                                                onChange={(e) => onChange(item.id, e)}
                                                className="form-control"
                                            >
                                                <option
                                                    key={`option-${index}}`}
                                                >
                                                </option>
                                                {
                                                    (item.options && !window._.isEmpty(item.options)) ? Object.keys(item.options).map(k => {
                                                        return (
                                                            <option
                                                                key={`option-${index}-${item.options[k]}`}
                                                                value={item.options[k]}>
                                                                {item.options[k]}
                                                            </option>
                                                        )
                                                    }) : null
                                                }
                                            </select>
                                        )

                                        const legend = item.legend ? (
                                            <div
                                                className="question__legend mt-2"
                                                dangerouslySetInnerHTML={{
                                                    __html: item.legend
                                                }} />
                                        ) : null

                                        return (
                                            <Row
                                                key={`question-${index}`}
                                                className="question my-2 py-4 px-2">
                                                <div className="col-12 question__sentence">
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: item.content
                                                        }} />
                                                    {legend}
                                                </div>
                                                <div className="col-12 question__answer">
                                                    {answer}
                                                </div>
                                            </Row>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    )
                }) : "No questions"
            }
            <Row>
                <div
                    className="col"
                >
                    {
                        formErrors ? (
                            <div
                                className="py-3 text-danger">
                                {formErrors}
                            </div>
                        ) : null
                    }
                    {
                        window._.get(formFeedback, episode.id) ? null : (
                            <div
                                className="pb-3"
                            >
                                <Button
                                    disabled={buttonIsDisabled()}
                                    onClick={sendAnswers}
                                    size="sm"
                                >
                                    {
                                        loading ? "Please wait" : "Confirm"
                                    }
                                </Button>
                            </div>
                        )
                    }

                </div>
            </Row>
        </Container >

    ) : (
        <Container fluid={true}>
            <Row className="mb-3 py-4">
                {userEpisodes.map(_episode => {
                    const _answered = window._.get(user, `answers.${_episode.id}.answered`) || answered.includes(_episode.id)
                    return (
                        <div
                            className={classNames("col-12 mt-3 evaluation-form__question", {
                                answered: _answered
                            })}
                            onClick={() => {
                                if (_answered) {
                                    return false
                                }
                                else {
                                    setEpisode(_episode)
                                }
                            }}
                        >
                            <div className="evaluation-form__question--title">
                                {_episode.evaluation_form_title || _episode.title}
                            </div>
                            {
                                _answered ? (
                                    <div>
                                        <em>
                                            {props.alreadyAnsweredMessage}
                                        </em>
                                    </div>
                                ) : null
                            }
                        </div>
                    )
                })}
                <div
                    className="text-center mt-4 py-0 px-2"
                >
                    <Button
                        onClick={close}
                        size="sm"
                        className="mx-2 btn-email-confirmation"
                    >
                        Close
                    </Button>
                </div>
            </Row>
        </Container>
    )

    // const modal = (
    //     <AdamModal
    //         content={grid}
    //         open={modalOpen}
    //         // fluidHeader={true}
    //         onClose={() => close()}
    //     />
    // )

    return (
        <Container>{grid}</Container>
    )
}

export default EvaluationForm